module.exports = __webpack_public_path__ + "static/img/IMG_20240610_121808.ef77f609.jpg";